import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCarBattery,
  faToilet,
  faVanShuttle,
  faSink,
  faSnowflake,
  faChair,
  faFireBurner,
  faMosquitoNet,
  faCircleHalfStroke,
  faHome,
  faShower,
  faBars,
  faMagnifyingGlass,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const navbarRef = useRef(null);
  const [transitionsEnabled, setTransitionsEnabled] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const toggleMenu = () => {
    const newState = !isOpen;
    setIsOpen(newState);

    if (!newState && navbarRef.current) {
      navbarRef.current.scrollTop = 0;
    }

    setTransitionsEnabled(true);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    if (navbarRef.current) {
      navbarRef.current.scrollTop = 0;
    }
  };

  const location = useLocation();
  const navigate = useNavigate();

  const handleNavItemClick = (route) => {
    setTransitionsEnabled(false);
    navigate(route);
    handleLinkClick();
  };

  return (
    <nav className="header">
      <div className="inner-header">
        <div className="brand">
          <Link to="/" className="logo-link" onClick={handleLinkClick}>
            <img
              src="/horizontalLogo.png"
              alt="Apex Campervans Logo"
              id="home-logo"
            />
          </Link>
        </div>
        <button
  className={`menu-icon ${isOpen ? "open" : ""}`}
  id="menuIcon"
  onClick={toggleMenu}
  aria-label="Toggle menu"
>
  <span></span>
  <span></span>
  <span></span>
</button>
          {/* <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </button> */}
        <div
          className={`navbar ${isOpen ? "navactive" : ""} ${
            transitionsEnabled ? "transition-enabled" : ""
          }`}
          id="nav"
          ref={navbarRef}
        >
          <ul>
            <li onClick={() => handleNavItemClick("/")}>
              <FontAwesomeIcon
                icon={faHome}
                className={`nav-icon ${
                  location.pathname === "/" ? "active" : ""
                }`}
              />
              <div className="nav-text">Home</div>
            </li>
            <li onClick={() => handleNavItemClick("/van-operation")}>
              <FontAwesomeIcon
                icon={faVanShuttle}
                className={`nav-icon ${
                  location.pathname === "/van-operation" ? "active" : ""
                }`}
              />
              <div className="nav-text">Van Operation</div>
            </li>
            <li onClick={() => handleNavItemClick("/batteries")}>
              <FontAwesomeIcon
                icon={faCarBattery}
                className={`nav-icon ${
                  location.pathname === "/batteries" ? "active" : ""
                }`}
              />
              <div className="nav-text">Batteries</div>
            </li>
            <li onClick={() => handleNavItemClick("/sink")}>
              <FontAwesomeIcon
                icon={faSink}
                className={`nav-icon ${
                  location.pathname === "/sink" ? "active" : ""
                }`}
              />
              <div className="nav-text">Sink</div>
            </li>
            <li onClick={() => handleNavItemClick("/toilet")}>
              <FontAwesomeIcon
                icon={faToilet}
                className={`nav-icon ${
                  location.pathname === "/toilet" ? "active" : ""
                }`}
              />
              <div className="nav-text">Toilet</div>
            </li>
            <li onClick={() => handleNavItemClick("/air-conditioning")}>
              <FontAwesomeIcon
                icon={faSnowflake}
                className={`nav-icon ${
                  location.pathname === "/air-conditioning" ? "active" : ""
                }`}
              />
              <div className="nav-text">A/C</div>
            </li>
            <li onClick={() => handleNavItemClick("/swivel-seat")}>
              <FontAwesomeIcon
                icon={faChair}
                className={`nav-icon ${
                  location.pathname === "/swivel-seat" ? "active" : ""
                }`}
              />
              <div className="nav-text">Swivel Seat</div>
            </li>
            <li onClick={() => handleNavItemClick("/induction-stoves")}>
              <FontAwesomeIcon
                icon={faFireBurner}
                className={`nav-icon ${
                  location.pathname === "/induction-stoves" ? "active" : ""
                }`}
              />
              <div className="nav-text">Induction Stoves</div>
            </li>
            <li onClick={() => handleNavItemClick("/shower")}>
              <FontAwesomeIcon
                icon={faShower}
                className={`nav-icon ${
                  location.pathname === "/shower" ? "active" : ""
                }`}
              />
              <div className="nav-text">Shower</div>
            </li>
            <li onClick={() => handleNavItemClick("/bug-net")}>
              <FontAwesomeIcon
                icon={faMosquitoNet}
                className={`nav-icon ${
                  location.pathname === "/bug-net" ? "active" : ""
                }`}
              />
              <div className="nav-text">Bug Net</div>
            </li>
            <li onClick={() => handleNavItemClick("/window-covers")}>
              <FontAwesomeIcon
                icon={faCircleHalfStroke}
                className={`nav-icon ${
                  location.pathname === "/window-covers" ? "active" : ""
                }`}
              />
              <div className="nav-text">Window Covers</div>
            </li>
          </ul>
          {isOpen && (
            <div className="navbar-close" onClick={toggleMenu}>
              Close
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Header;
